import { styled, keyframes } from 'styled-components';
import { motion } from 'framer-motion';

const AboutStyles = styled(motion.div)`
  padding: 0 4vw;
  padding-bottom: 6vw;
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .hello {
    h1 {
      font-size: calc(var(--VW) * 2);
      text-transform: uppercase;
      text-align: center;
      opacity: 0.7;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        font-size: calc(var(--VW) * 6);
      }
    }
  }
  .name {
    margin: 10vh 0 20vh 0;
    h1 {
      font-size: calc(var(--VW) * 12);
      line-height: 10vw;
      height: 10vw;
      -webkit-text-fill-color: transparent;
      -webkit-text-stroke: 0.2vw var(--dullWhite);
      opacity: 0.7;
      text-transform: uppercase;
      :nth-child(3) {
        text-align: right;
      }
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        line-height: 5vw;
        height: 5vw;
        -webkit-text-stroke: 0.3vw var(--dullWhite);
      }
    }
    h3 {
      font-size: calc(var(--VW) * 3);
      text-align: center;
      text-transform: uppercase;
      z-index: 5;
      opacity: 0.8;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        font-size: calc(var(--VW) * 7);
      }
    }
  }
  .split {
    margin: 5vh 0;
    h1 {
      text-transform: uppercase;
      font-size: calc(var(--VW) * 3.5);
      opacity: 0.8;
      -webkit-text-fill-color: var(--eerieDark);
      -webkit-text-stroke: 0.1vw var(--dullWhite);
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        font-size: calc(var(--VW) * 5);
        -webkit-text-stroke: 0.15vw var(--dullWhite);
      }
    }
  }
  .contact {
    margin: 5vw;
    text-align: right;
    h1 {
      font-size: calc(var(--VW) * 6);
      text-transform: uppercase;
      opacity: 0.8;
    }
    a {
      font-size: calc(var(--VW) * 9);
      text-transform: uppercase;
      -webkit-text-fill-color: var(--eerieDark);
      -webkit-text-stroke: 0.2vw var(--dullWhite);
      opacity: 0.7;
      &:hover {
        -webkit-text-fill-color: var(--dullWhite);
        -webkit-text-stroke: 0.14vw var(--eerieDark);
      }
    }
  }
`;

const BigTextStyles = styled.div`
  height: 100vh;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  margin-bottom: 10vh;
  .container {
    overflow: hidden;
    width: 100%;
    margin-left: 3rem;
    :nth-child(2) {
      text-align: right;
    }
    :nth-child(3) {
      padding-left: 15vw;
    }
    h1 {
      text-transform: uppercase;
      font-size: calc(var(--VW) * 11);
      line-height: 10vw;
      height: 10vw;
      overflow: hidden;
      opacity: 0.8;
      -webkit-text-stroke: calc(var(--VW) * 0.3) var(--jet);
    }
  }
`;

const ContentAreaStyles = styled(motion.div)`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: space-between;
  padding: 2vw;
  @media (hover: none) and (pointer: coarse) {
    padding: 10vh 5vw;
  }
  .names {
    height: 90%;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 100%;
    }
  }
`;

const coverReveal = keyframes`
    from{
        left: 0%;
    }
    to {
        left: 120%;
    }
`;

const CoverStyles = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vw;
  z-index: 15;
  background-color: transparent;
  animation: ${coverReveal} 0.01s linear 6.5s forwards;
`;

const CursorStyles = styled(motion.div)`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 0.36vw;
  height: 0.36vw;
  padding: 1.5vw;
  border-radius: 100%;
  background-color: var(--eerieDark);
  border: 0.1vw solid var(--eerieDark);
  mix-blend-mode: difference;
  z-index: 20;
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    display: none;
  }
`;

const DesktopSectionStyles = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 15vh 0;
  .main {
    width: 55%;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 100%;
    }
  }
  .side {
    width: 35%;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 100%;
    }
  }
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    flex-wrap: wrap;
    margin: 5vh 0;
  }
`;

const InfoStyles = styled.div`
  margin-bottom: 20vh;
  margin-right: 5vw;
  display: flex;
  justify-content: space-between;
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    flex-wrap: wrap;
    margin-bottom: 10vh;
  }
  .info-main {
    width: 48%;
    opacity: 0.8;
    font: 'Poppins';
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 95%;
    }
    h2 {
      font-size: calc(var(--VW) * 2);
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        font-size: calc(var(--VW) * 4);
      }
    }
    p {
      margin-bottom: 3vw;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        margin-bottom: 5vw;
      }
      :last-child {
        margin-bottom: 0;
      }
    }
  }
  .info-credits {
    width: 35%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    opacity: 0.8;
    font: 'Poppins';
    @media (hover: none) and (pointer: coarse) {
      width: 68%;
      margin-top: 10vh;
    }
    @media (hover: none) and (pointer: coarse) and (max-width: 500px) {
      width: 80%;
      margin-top: 10vh;
    }
    h1 {
      font-size: calc(var(--VW) * 4);
      -webkit-text-fill-color: var(--eerieDark);
      -webkit-text-stroke: 0.1vw var(--dullWhite);
      opacity: 0.85;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        font-size: calc(var(--VW) * 6);
        -webkit-text-stroke: 0.15vw var(--dullWhite);
      }
    }
    h2 {
      font-size: calc(var(--VW) * 2);
      margin: 0.5vw 0;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        font-size: calc(var(--VW) * 4);
      }
      :last-child {
        margin-bottom: 0;
      }
    }
    p {
      margin-bottom: 3vw;
      font-family: 'Poppins';
      :nth-child(2) {
        margin-bottom: 1vw;
        margin-top: 0.5vw;
      }
    }
  }
`;

const LandscapeStyles = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: var(--eerieDark);
  z-index: 50;
  display: none;
  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {
    display: flex;
  }
  .content {
    height: 20%;
    text-align: center;
    svg {
      height: 100%;
    }
  }
`;

const MainSectionStyles = styled.div`
  margin: 20vh 0;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 10vh;
  }
  .main-pic {
    width: 20vw;
    height: 20vw;
    margin-right: 5vw;
    text-align: center;
    overflow: hidden;
    border-radius: 24px;
    opacity: 0;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 100%;
      width: 50vw;
      height: 55vw;
    }
  }
  .main-text {
    width: 45%;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 95%;
    }
    p {
      margin: 3vw 0;
      mix-blend-mode: normal;
      font-family: 'Beckman';
      opacity: 0.7;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        margin: 5vw 0;
      }
      a {
        font-family: Grotesk;
        text-transform: none;
        mix-blend-mode: normal;
      }
    }
  }
`;

const MarqueeStyles = styled.div`
  position: relative;
  left: -10vw;
  .left,
  .right {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    span {
      position: relative;
      display: inline-block;
      font-family: Monument;
      font-weight: 100;
      font-size: calc(var(--VW) * 8);
      text-transform: uppercase;
      padding-right: 2vw;
    }
  }
  .left {
    span {
      border-top: 0.5vw solid var(--onyx);
      border-bottom: 0.5vw solid var(--onyx);
    }
  }
  .right {
    span {
      border-bottom: 0.5vw solid var(--onyx);
    }
  }
`;

const MenuStyles = styled(motion.div)`
  height: 100vh;
  display: flex;
  justify-content: space-between;
  padding: 2vw;
  @media (hover: none) and (pointer: coarse) {
    width: 100vw;
    padding: 10vh 5vw;
    flex-direction: column-reverse;
  }
  .left {
    height: 85%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    }

    &-bottom {
      height: 5vh;
      margin-left: 2rem;
      overflow: hidden;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        height: 15vh;
      }
      a {
        margin-right: 3vw;
        display: inline-block;
        svg {
          pointer-events: none;
          width: 2.5vw;
          height: 2.5vw;
          mix-blend-mode: normal;
          color: var(--dullWhite);
          background-color: var(--eerieDark);
          border-radius: 50%;
          &:hover {
            color: var(--black);
            background-color: var(--black);
          }
          @media (hover: none) and (pointer: coarse), (max-width: 500px) {
            width: 8.5vw;
            height: 8.5vw;
          }
        }
      }
    }
  }
  .right {
    height: 85%;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 90%;
      height: 70%;
    }

    &-bottom {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex-grow: 1;
      max-height: 40vh;
      position: relative;
      top: 1%;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        margin-top: 0;
        margin-bottom: 5vh;
      }
      .link-container {
        overflow: hidden;
        text-align: right;
        :nth-child(1) {
          padding-right: 2rem;
          @media (hover: none) and (pointer: coarse), (max-width: 500px) {
            padding-right: 0;
          }
        }
        :nth-child(3) {
          padding-right: 10vw;
          @media (hover: none) and (pointer: coarse), (max-width: 500px) {
            padding-right: 0;
          }
        }
        .link-wrapper {
          a {
            display: inline-block;
            font-size: calc(var(--VW) * 7);
            line-height: calc(var(--VW) * 6);
            height: calc(var(--VW) * 6);
            -webkit-tap-highlight-color: transparent;
            @media (hover: none) and (pointer: coarse), (max-width: 500px) {
              font-size: calc(var(--VW) * 10);
              line-height: calc(var(--VW) * 11);
              height: calc(var(--VW) * 11);
            }
            .number {
              pointer-events: none;
              font-size: calc(var(--VW) * 2);
              @media (hover: none) and (pointer: coarse), (max-width: 500px) {
                font-size: calc(var(--VW) * 3);
              }
            }
          }
        }
      }
    }
  }
`;

const NamesStyles = styled(motion.div)`
  text-align: left;
  .name-wrapper {
    overflow: hidden;
    li {
      font-family: Anton;
      font-weight: 400;
      font-size: calc(var(--VW) * 7.5);
      display: inline-block;
      height: calc(var(--VW) * 5);
      text-transform: uppercase;
      opacity: 0.8;
      -webkit-text-fill-color: var(--deepBlack);
      -webkit-text-stroke: calc(var(--VW) * 0.1) var(--dullWhite);
      @media (hover: none) and (pointer: coarse) {
        font-size: calc(var(--VW) * 17);
        line-height: calc(var(--VW) * 16);
        height: calc(var(--VW) * 20);
        -webkit-text-stroke: calc(var(--VW) * 0.25) var(--dullWhite);
        opacity: 0.87;
      }
    }
  }
`;

const NavStyles = styled.div`
  .logo,
  .projects,
  .about {
    position: fixed;
    z-index: 20;
  }

  .logo {
    top: 2vw;
    left: 2vw;
    width: 3.2vw;
    height: 3.2vw;
    mix-blend-mode: normal;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 10vw;
      height: 10vw;
    }
    svg {
      width: 100%;
      height: 100%;
      pointer-events: none;
      color: var(--black);
    }
  }

  .projects,
  .about {
    transition: 0.3s all ease;
    transform: rotate(90deg);
    transform-origin: 0% 0%;
    right: -3vw;
    font-size: calc(var(--VW) * 1.5);
    opacity: 0.8;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      font-size: calc(var(--VW) * 4);
      right: -12vw;
    }
    :hover {
      -webkit-text-fill-color: var(--deepBlack);
      -webkit-text-stroke: calc(var(--VW) * 0.03) var(--dullWhite);
    }
  }

  .projects {
    top: 2.2vw;
    right: -8.8vw;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      right: -25.5vw;
    }
  }

  .about {
    bottom: 6.5vw;
    right: -5vw;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      right: -16vw;
      bottom: 16vw;
    }
  }
`;

const PanelStyles = styled(motion.div)`
  position: absolute;
  left: 0;
  bottom: 0;
  width: calc(var(--VW) * 100);
  height: calc(var(--VH) * 100);
  z-index: 100;
  pointer-events: none;
  .left,
  .right {
    height: 100%;
    width: 50.5%;
    position: absolute;
    top: 0;
    z-index: 30;
    background-color: var(--eerieDark);
  }

  .left {
    left: 0;
  }

  .right {
    right: 0;
  }
  .message {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    color: var(--dullWhite);
    font-size: calc(var(--VW) * 2);
    z-index: 31;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      font-size: calc(var(--VW) * 4);
    }
  }
`;

const PhoneSectionStyles = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin: 15vh 10vw;
  justify-content: space-around;
  .image-wrapper {
    width: 28%;
    @media (max-width: 500px) {
      width: 100%;
    }
    :nth-child(2) {
      width: 30%;
      position: relative;
      top: -1vw;
      @media (max-width: 500px) {
        width: 100%;
      }
    }
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
  @media (max-width: 500px) {
    flex-wrap: wrap;
  }
`;

const PointerStyles = styled.div`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 0.6vw;
  height: 0.6vw;
  border-radius: 100%;
  background-color: var(--dullWhite);
  transform: translate(-50%, -50%);
  z-index: 20;
  &.on-focus {
    display: none;
  }
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    display: none;
  }
`;

const PrimarySectionStyles = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  justify-content: flex-end;
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    justify-content: flex-start;
  }
  .content {
    width: 40%;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 95%;
    }
    .title-wrapper {
      overflow: hidden;
      margin-bottom: 3vw;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        margin-bottom: 6vw;
      }
      .title {
        font-size: calc(var(--VW) * 3);
        position: relative;
        opacity: 0.8;
        @media (hover: none) and (pointer: coarse), (max-width: 500px) {
          font-size: calc(var(--VW) * 8);
        }
      }
      .underline {
        width: 30%;
        height: 0.3vw;
        background-color: var(--dullWhite);
        opacity: 0.8;
      }
    }
    .links {
      text-align: right;
      margin-bottom: 2vw;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        margin-bottom: 4vw;
      }
      a {
        height: 100%;
        display: inline-block;
        margin: 0 0.5vw;
        @media (hover: none) and (pointer: coarse), (max-width: 500px) {
          margin: 0 2vw;
        }
        svg {
          width: 3.5vw;
          height: 3.5vw;
          pointer-events: none;
          mix-blend-mode: normal;
          color: var(--dullWhite);
          background-color: var(--eerieDark);
          border-radius: 50%;
          opacity: 0.8;
          &:hover {
            color: var(--black);
            background-color: var(--black);
          }
          @media (hover: none) and (pointer: coarse) and (min-width: 500px) {
            width: 8vw;
            height: 8vw;
            mix-blend-mode: unset;
          }
          @media (max-width: 500px) {
            width: 12vw;
            height: 12vw;
            mix-blend-mode: unset;
          }
        }
      }
    }
    .text {
      margin-bottom: 3vw;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        margin-bottom: 5vw;
      }
    }
  }
`;

const ProjectFooterStyles = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: calc(var(--VW) * 3);
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    font-size: calc(var(--VW) * 6);
  }
  .next {
    opacity: 0.8;
    span {
      position: relative;
      top: -5%;
      right: 5%;
      transition: 0.3s all ease-out;
      pointer-events: none;
    }
    &:hover {
      span {
        right: -5%;
        transition: 0.3s all ease-out;
      }
    }
  }
`;

const ProjectsItemStyles = styled.li`
  width: 100%;
  position: relative;
  a {
    height: 100%;
    .wrapper {
      height: 100%;
      display: flex;
      align-items: flex-end;
      pointer-events: none;
      .title {
        margin: 0 1vw;
        h2 {
          overflow: hidden;
          opacity: 0.6;
          :hover {
            -webkit-text-stroke: calc(var(--VW) * 0.1) var(--dullWhite);
          }
          .text {
            font-size: calc(var(--VW) * 2.8);
            @media (hover: none) and (pointer: coarse), (max-width: 500px) {
              position: relative;
              top: 0.7vh;
              font-size: calc(var(--VW) * 7);
            }
          }
        }
      }
      .thumbnail {
        overflow: hidden;
        position: absolute;
        height: 7vw;
        width: 7vw;
        font-size: calc(var(--VW) * 3.5);
        @media (hover: none) and (pointer: coarse), (max-width: 500px) {
          /* width: 10vw; */
          display: none;
        }
        .mask {
          width: 80%;
          height: 80%;
          position: absolute;
          top: 0;
          z-index: 9;
          background-color: var(--eerieBlack);
          @media (hover: none) and (pointer: coarse), (max-width: 500px) {
            /* width: 10vw; */
            display: none;
          }
        }
        .cover {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          z-index: 10;
          background-color: var(--eerieBlack);
        }
        img {
          position: absolute;
          height: 100%;
          width: 100%;
          right: 0;
          display: block;
        }
      }
      .floating-image {
        pointer-events: none;
        height: 22vw;
        width: auto;
        position: absolute;
        z-index: 10;
        overflow: hidden;
        opacity: 0.8;
        @media (hover: none) and (pointer: coarse), (max-width: 500px) {
          display: none;
        }
        img {
          height: 100%;
          width: auto;
          display: block;
          opacity: 0.8;
        }
      }
      .line {
        height: 0.1vw;
        width: 100%;
        background-color: var(--dullWhite);
        position: relative;
        display: flex;
        align-items: center;
        bottom: 1vw;
        opacity: 0.6;
        &.flex-0 {
          flex: 0;
          &::after {
            display: none;
          }
        }
        &.flex-1 {
          flex: 1;
        }
        &.flex-2 {
          flex: 2;
        }
        &.flex-3 {
          flex: 3;
        }
        &::after {
          content: '';
          position: absolute;
          height: 0.5vw;
          width: 0.5vw;
          border-radius: 100%;
          background-color: var(--dullWhite);
          opacity: 0.95;
        }
        &.left {
          &::after {
            right: 0;
          }
        }
        .mask {
          width: 100%;
          height: 0.6vw;
          z-index: 9;
          position: absolute;
          background-color: var(--eerieBlack);
        }
        .cover {
          width: 100%;
          height: 0.6vw;
          z-index: 10;
          position: absolute;
          background-color: var(--eerieBlack);
        }
      }
    }
  }
`;

const ProjectStyles = styled(motion.div)`
  padding: 6vw 5vw;
  padding-right: 6vw;
  .number {
    display: flex;
    justify-content: flex-start;
    position: relative;
    left: -26%;
    overflow: hidden;
    margin: 5vw 0;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      left: -38%;
      width: 120%;
      margin: 15vw 0;
    }
    &-wrapper {
      overflow: hidden;
      h1 {
        font-size: calc(var(--VW) * 40);
        line-height: 33vw;
        height: 33vw;
        position: relative;
        bottom: -10%;
        @media (hover: none) and (pointer: coarse), (max-width: 500px) {
          font-size: calc(var(--VW) * 60);
          line-height: 50vw;
          height: 50vw;
        }
      }
    }
  }
`;

const ProjectsStyles = styled(motion.div)`
  width: 100vw;
  height: 100vh;
  padding: 6vw 4vw;
  display: flex;
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    padding: 6vw 10vw;
  }
  .title-wrapper {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      display: none;
    }
    .title {
      .word-wrapper {
        overflow: hidden;
        :nth-child(2) {
          position: relative;
          left: 15%;
        }
        .word {
          font-family: 'Anton';
          font-size: calc(var(--VW) * 5.3);
          text-transform: uppercase;
          opacity: 0.7;
          -webkit-text-fill-color: var(--deepBlack);
          -webkit-text-stroke: calc(var(--VW) * 0.1) var(--dullWhite);
        }
      }
    }
  }
  .content {
    width: 70%;
    height: 100%;
    padding: 0 2vw;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 100%;
      padding: 5vh 0 10vh 0;
    }
    .works-list {
      width: 100%;
      height: 100%;
      display: flex;
      align-content: space-between;
      flex-wrap: wrap;
    }
  }
`;

const SecondarySectionStyles = styled.div`
  margin: 20vh 10vw;
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    margin: 10vh 0;
  }
  .content {
    h2 {
      font-size: calc(var(--VW) * 2);
      opacity: 0.8;
      @media (hover: none) and (pointer: coarse), (max-width: 500px) {
        font-size: calc(var(--VW) * 6);
      }
    }
  }
`;

const TabletSectionStyles = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 15vh 0;
  .main {
    width: 60%;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 100%;
    }
  }
  .side {
    width: 35%;
    @media (hover: none) and (pointer: coarse), (max-width: 500px) {
      width: 100%;
    }
  }
  @media (hover: none) and (pointer: coarse), (max-width: 500px) {
    flex-wrap: wrap;
    margin: 5vh 0;
  }
`;

export {
  AboutStyles,
  BigTextStyles,
  ContentAreaStyles,
  coverReveal,
  CoverStyles,
  CursorStyles,
  DesktopSectionStyles,
  InfoStyles,
  LandscapeStyles,
  MainSectionStyles,
  MarqueeStyles,
  MenuStyles,
  NamesStyles,
  NavStyles,
  PanelStyles,
  PhoneSectionStyles,
  PointerStyles,
  PrimarySectionStyles,
  ProjectFooterStyles,
  ProjectsItemStyles,
  ProjectStyles,
  ProjectsStyles,
  SecondarySectionStyles,
  TabletSectionStyles,
};
